import { Badge } from "flowbite-react";
import { formatToReal } from "../../../utils/utils";

const ProtestosDirCartorio = ({ protestosDirCartorio, quantidadeTotal }) => {
  return (
    <>
      {/* Resumo */}
      <div className="flex flex-wrap gap-3 mb-5">
        {quantidadeTotal && (
          <div className="flex items-center gap-2 bg-red-50 border border-red-100 text-red-700 px-4 py-2 rounded-full text-sm font-medium">
            <span>Quantidade:</span>
            <span>{quantidadeTotal}</span>
          </div>
        )}
      </div>

      {/* Listagem */}
      <div className="rounded-2xl border border-gray-200 overflow-hidden">
        <div className="bg-blue-50 px-4 py-3 border-b border-gray-200">
          <div className="grid grid-cols-4 gap-4 text-xs font-semibold text-gray-600 uppercase tracking-wider">
            <div>Cartório</div>
            <div>Cidade</div>
            <div>UF</div>
            <div>Valor</div>
          </div>
        </div>

        {protestosDirCartorio?.map((protesto, index) => (
          <div
            key={index}
            className={`grid grid-cols-4 gap-4 px-4 py-3 text-sm items-center ${
              index % 2 === 0 ? "bg-white" : "bg-gray-50"
            }`}
          >
            <div className="font-medium text-gray-900">
              {protesto?.cartorio || "-"}
            </div>
            <div className="text-gray-700">{protesto?.cidade || "-"}</div>
            <div className="text-gray-700">{protesto?.estado || "-"}</div>
            <div className="font-semibold text-red-700">
              {formatToReal(protesto?.valor)}
            </div>
          </div>
        ))}
      </div>

      <div className="text-sm mt-4 text-gray-500">
        Exibindo {protestosDirCartorio?.length || 0} registros.
      </div>
    </>
  );
};

export default ProtestosDirCartorio;
